import type { AreRouteGeometriesEqual } from "./types";

export const areRouteGeometriesEqual: AreRouteGeometriesEqual = ({
  first,
  second,
}) => {
  if (first.nodes.length !== second.nodes.length) return false;
  if (first.edges.length !== second.edges.length) return false;

  for (let index = 0; index < first.nodes.length; index++) {
    const firstNode = first.nodes[index];
    const secondNode = second.nodes[index];
    if (
      firstNode.id !== secondNode.id ||
      firstNode.x !== secondNode.x ||
      firstNode.y !== secondNode.y
    ) {
      return false;
    }
  }

  for (let index = 0; index < first.edges.length; index++) {
    const firstEdge = first.edges[index];
    const secondEdge = second.edges[index];
    if (firstEdge.from !== secondEdge.from || firstEdge.to !== secondEdge.to) {
      return false;
    }
  }

  return true;
};
